import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
//import { MyUrl } from "../../../App";
import moment from "moment";
import { Checkbox } from "@mui/material";
//mport { makeStyles } from "@material-ui/core/styles";
//import { withStyles } from "@mui/styles";
//import CheckIcon from "@material-ui/icons/Check";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
//import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
//import IncomeFirstTable from "./IncomeFirstTable";
//import IncomeGraph from "./IncomeGraph";
//import IncomeSecondTable from "./IncomeSecondTable";
import jwt_decode from "jwt-decode";
import Lottie from "lottie-react";
import UnboxtheBlackbox from "../../UnboxtheBlackbox.json";
// import loading33refresh from "../../../loading33refresh.json";
// import loadingrefresh from "../../../loadingrefresh.json";
// import refreshicon from "../../../refreshicon.json";
import Textarea from "@mui/joy/Textarea";

import reloadpage from "../../reloadpage.json";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import { Button, Modal, Divider, Input, Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import DashboardFirstTable from "../DashboardComponents/DashboardFirstTable";
import SourceManagementFirstTable from "../SourceManagementComponents/SourceManagementFirstTable";
import MainPageLeftDrawer from "./MainPageLeftDrawer";
import add from "../../Images/add.png";
import AutoTasksFirstTable from "../AutoTasksComponents/AutoTasksFirstTable";
import WhiteListsFirstTable from "../WhiteListsComponents/WhiteListsFirstTable";
var SendDataToFirstTable = [];
var ObjSendDataToFirstTable = {};
var ObjSendDataToFirstTable2 = {};

var jwtToken = "";

var SendDataToFirstTable1 = [];
var ObjSendDataToFirstTable1 = {};

var SendDataToIncomeGraph = [];
var ObjSendDataToIncomeGraph = {};
var SendDataToIncomeGraph1 = [];
var SendDataToSecondTable = [];
var SendDataToSecondTable1 = [];

var TotalOfDailyChange = 0;
var currentValue1 = 0;
var prevValue1 = 0;
var AfterCalc1 = currentValue1 - prevValue1;
var PickedDate = 0;

// const CircleCheckbox = ({ classes, ...props }) => (
//   <Checkbox
//     {...props}
//     classes={{
//       root: classes.root,
//       checked: classes.checked,
//     }}
//     icon={<span className={classes.circle} />}
//     checkedIcon={
//       <span className={classes.checkedIcon}>
//         sss
//         {/* <CheckIcon style={{ fontSize: 16, color: "black" }} /> */}
//       </span>
//     }
//   />
// );
function WhiteLists() {
  //when pick today
  const Today = moment().add("days").format("YYYY-MM-DD");
  //when pick yesterday
  const Yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
  //when pick 7 days
  const SevenDays = moment().subtract(7, "day").format("YYYY-MM-DD");

  //For CheckBox
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  //End for CheckBox

  //Select Days
  const [days, setDays] = React.useState(0);
  const handleChangeDays = (event) => {
    setDays(event.target.value);
    // PickDatesToGetData(event.target.value);
  };
  //End select Days

  const [OpenRange, SetOpenRange] = useState(false);
  var startDate = Today;
  var endDate = Today;

  async function PickDatesToGetData(event) {
    setDays(event);
    if (event === 0) {
      SetOpenRange(false);
      startDate = Today;
      endDate = Today;
      console.log("today1");

      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
      // GetDailyIncomeFunc1(Today, Today);
      // GetMonthlyIncomeFunc(Today, Today);
    } else if (event === 1) {
      SetOpenRange(false);
      startDate = Yesterday;
      endDate = Yesterday;
      console.log("Yesterday1");
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    } else if (event === 2) {
      SetOpenRange(false);
      startDate = SevenDays;
      endDate = Yesterday;
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    } else if (event === 3) {
      SetOpenRange(false);
      startDate = FirstDayInMonth;
      endDate = Yesterday;
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    } else if (event === 4) {
      if (value.$D === undefined) {
        startDate = Today;
      } else {
        startDate = `${value.$y}-${value.$M + 1}-${value.$D}`;
      }
      if (value1.$D === undefined) {
        endDate = Today;
      } else {
        endDate = `${value1.$y}-${value1.$M + 1}-${value1.$D}`;
      }
      SetOpenRange(true);
      await getCustomersData(startDate, endDate);
      //await RefreshFunc(startDate, endDate);
    }
  }
  const [height, width] = useWindowSize();

  const [Loading, setLoading] = useState(false);
  const [chooceCompanies, setChooceCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState("");
  const [isLoading1, setIsLoading1] = useState(true);
  const [data1, setData1] = useState("");
  const [isLoading2, setIsLoading2] = useState(true);
  const [data2, setData2] = useState("");

  var LastDayInMonth = moment(LastDayInMonth)
    .endOf("month")
    .format("YYYY-MM-DD");

  var FirstDayInMonth = moment(FirstDayInMonth)
    .startOf("month")
    .format("YYYY-MM-DD");

  const currentDate = moment();
  const daysInCurrentMonth = currentDate.daysInMonth();
  const [selectedObject, setSelectedObject] = useState(true);
  const [count, setCount] = useState(0);

  const handleCheckboxChange = (event, productName) => {
    if (event.target.checked) {
      setChooceCompanies([...chooceCompanies, productName]); // add to array
    } else {
      setChooceCompanies(
        chooceCompanies.filter((name) => name !== productName)
      );
      console.log(chooceCompanies);
      console.log(SendDataToSecondTable);
      console.log("SendDataToIncomeGraph1");
      console.log(SendDataToSecondTable1);
    }
  };
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const urlParams1 = window.location.search;

  //console.log(urlParams1.replace("?", ""));
  const IdsToGetData = []; //chooceCompanies.map((id) => "," + String(id)).join("");

  const getCustomersData1 = () => {
    setIsLoading(true);
    try {
      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetSeats?clearCacheForUpload=false`
        )
        .then((res) => {
          const data = res.data;
          setData(data);
          //console.log(data);
          for (let i = 0; i < data.length; i++) {
            //console.log(data[i].id);
            IdsToGetData.push(data[i].id);
            //console.log(IdsToGetData);

            setChooceCompanies((prevCompanies) => [
              ...prevCompanies,
              data[i].id,
            ]);
          }
          getCustomersData(startDate, endDate);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading(false);
        });
    } catch (err) {}
  };

  const items = localStorage.getItem("Token");

  const trimmedMyaa = items.substring(1, items.length - 1);
  const aa = trimmedMyaa.replace("?jwt=", "");
  //console.log(aa);

  const [ObjectForChange, setObjectForChange] = useState({});

  const getCustomersData = (startDate, endDate) => {
    try {
      setLoading(false);
      // console.log(endDate);
      // console.log(chooceCompanies.toString());
      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetWhiteLists`,
          // `https://dsp-api.o2rintelligence.com/api/Dashboard/GetDashboardReport?dateFrom=${startDate}&dateTo=${endDate}&seatids=${chooceCompanies.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${aa}`,
            },
            //cancelToken: source.token,
          }
        )
        .then((res) => {
          const data = res.data;
          console.log(data);
          SendDataToFirstTable = [];
          for (let i = 0; i < data.length; i++) {
            ObjSendDataToFirstTable = {
              name: data[i].name,
              bundles: data[i].bundles.length,
              bundlesData: data[i].bundles,
              sources:
                data[i].sources.length >= 1 ? data[i].sources[0].name : "",
              seatName: data[i].seatName,
              environment: data[i].environment,
              id: data[i].id,
              seatId: data[i].seatId,
              sourceId: data[i].sourceId,
              sourceName: data[i].sourceName,
              channelId: data[i].channelId,
              channelName: data[i].channelName,
              targeting: data[i].targeting,
              trafficSource: data[i].trafficSource,
              geo: data[i].geo,
              Action: data[i].seatName,
            };
            SendDataToFirstTable.push(ObjSendDataToFirstTable);
          }
        })

        .catch((error) => {})
        .finally(() => {
          setLoading(true);
        });
    } catch (err) {}
  };

  useEffect(() => {
    setChooceCompanies([]);
    getCustomersData1();
    //    getCustomersData1();
    const items = localStorage.getItem("Token");
    //console.log(items.replace("?jwt=", ""));
    //await getCustomersData(startDate, endDate, chooceCompanies.toString());
  }, []);
  var [value, setValue] = React.useState(startDate);
  var [value1, setValue1] = React.useState(endDate);
  const handleChange3 = (newValue) => {
    setValue(newValue);
    startDate = `${newValue.$y}-${newValue.$M + 1}-${newValue.$D}`;
  };

  const handleChange4 = (newValue1) => {
    setValue1(newValue1);
    endDate = `${newValue1.$y}-${newValue1.$M + 1}-${newValue1.$D}`;
  };
  const [isClicked, setIsClicked] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    console.log("Edit");
    EditSource();

    setIsModalOpen(false);
  };
  const handleCancel = () => {
    console.log("cancel");

    setIsModalOpen(false);
  };

  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const handleOk1 = () => {
    CreateNewSource();
    handleUpload();
    console.log("Create");
    setIsModalOpen1(false);
  };
  const handleCancel1 = () => {
    console.log("cancel");

    setIsModalOpen1(false);
  };
  const items2 = [
    {
      label: <a href="https://www.antgroup.com">1st menu item</a>,
      key: "0",
    },
    {
      label: <a href="https://www.aliyun.com">2nd menu item</a>,
      key: "1",
    },
    {
      type: "divider",
    },
    {
      label: "3rd menu item",
      key: "3",
    },
  ];

  const [Targeting, setTargeting] = React.useState();
  const [Geo, setGeo] = React.useState();

  const handleChangeTargeting = (event) => {
    setObjectForChange((prevState) => ({
      ...prevState,
      targeting: event.target.value,
    }));
    //setTargeting(event.target.value);
    //console.log(Targeting);
  };

  const handleChangeGeo = (event) => {
    setObjectForChange((prevState) => ({
      ...prevState,
      geo: event.target.value,
    }));
    //setGeo(event.target.value);
    //console.log(Geo);
  };

  const [dataFromChild, setDataFromChild] = useState(null);

  const receiveDataFromChild = (data) => {
    console.log(data);
    console.log(data.bundlesData);

    // Use the map function to extract the 'appsBundle' values
    const appsBundles = data.bundlesData.map((item) => item.appsBundle);

    // Join the extracted values into a single string
    const appsBundlesString = appsBundles.join(", "); // Separated by comma and space

    console.log(appsBundlesString);
    setIsModalOpen(data.dataToSend[0]);
    setDataFromChild(data);
    setIsModalOpen(true);
    setTargeting(data.targeting);
    setGeo(data.geo);
    setObjectForChange({
      ...ObjectForChange,
      id: data.id,
      geo: data.geo,
      seatId: data.seatId,
      targeting: data.targeting,
      sourceId: data.sourceId,
      sourceName: data.sourceName,
      environment: data.environment,
      name: data.name,
      bundlesData: data.bundlesData,
    });
    setIdForDelete2(data.id);
    setIdForUpdate2(data.id);
    console.log(dataFromChild);
    console.log(data.seatId);
    setSourceName2(data.name);
    setSeat2(data.seatId);
    setEnvironment2(data.environment);
    setBundles2(appsBundlesString);
    console.log("We have one");
  };

  const [ObjectForDelete, setObjectForDelete] = useState("");

  const receiveDataFromChildForDelete = (data) => {
    // console.log(data.dataToSendForDelete);
    // console.log(data.sourceId);
    setIsModalOpen2(data.dataToSendForDelete);
    setObjectForDelete(data.id);
    console.log(ObjectForDelete);
    console.log("We have one");
  };

  const [ObjectCreateSource, setObjectCreateSource] = useState({});
  const [Seat1, setSeat1] = useState("1");
  const [SourceName1, setSourceName1] = useState("");
  const [Environment1, setEnvironment1] = useState("CTV");
  const [Bundles1, setBundles1] = useState("");

  const [Geo1, setGeo1] = useState("US");

  const handleChangeSeat1 = (event) => {
    setSeat1(event.target.value);
    console.log(Seat1);
  };
  const handleChangeName1 = (event) => {
    setSourceName1(event.target.value);
    console.log(SourceName1);
  };

  const handleChangeEnvironment1 = (event) => {
    setEnvironment1(event.target.value);
    console.log(Environment1);
  };
  const handleChangeBundle1 = (event) => {
    setBundles1(event.target.value);
    console.log(Bundles1);
  };
  const handleChangeGeo1 = (event) => {
    setGeo1(event.target.value);
    console.log(Geo1);
  };

  const [IdForDelete2, setIdForDelete2] = useState("");

  //for Edit

  const [IdForUpdate2, setIdForUpdate2] = useState("");

  const [SourceName2, setSourceName2] = useState("");
  const [Seat2, setSeat2] = useState("");
  const [Environment2, setEnvironment2] = useState("");
  const [Bundles2, setBundles2] = useState("");

  const handleChangeSeat2 = (event) => {
    setSeat2(event.target.value);
    console.log(Seat2);
  };
  const handleChangeName2 = (event) => {
    setSourceName2(event.target.value);
    console.log(SourceName2);
  };

  const handleChangeEnvironment2 = (event) => {
    setEnvironment2(event.target.value);
    console.log(Environment2);
  };
  const handleChangeBundle2 = (event) => {
    setBundles2(event.target.value);
    console.log(Bundles2);
  };

  //End for Edit

  const CreateNewSource = async (event) => {
    var newObj = {
      //id: 0,
      //sourceId: SourceName1,
      seatId: 1,
      name: SourceName1,
      trafficSource: "",
      environment: Environment1,
      targeting: Bundles1,
      geo: Geo1,
      wl: "",
      whiteListId: "",
      prevWhiteListId: "",
    };
    try {
      //Array = Array.filter((item) => item !== timeTaken);
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/UpdateOrCreateWL`,
        newObj,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log("Created");
      getCustomersData(startDate, endDate);

      //CallData1();
    } catch (error) {
      console.log("error in Create Source");
    }
  };

  //484
  const DeleteSource = async (event) => {
    try {
      //Array = Array.filter((item) => item !== timeTaken);
      console.log(ObjectForDelete);
      const response = await axios.delete(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/DeleteWhiteList?id=${ObjectForDelete}`,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log("deleted");
      getCustomersData(startDate, endDate);

      //CallData1();
    } catch (error) {
      console.log("error in delete Source");
    }
  };
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const handleOk2 = () => {
    //CreateNewSource();
    DeleteSource();
    console.log("delete");
    setIsModalOpen2(false);
  };
  const handleCancel2 = () => {
    console.log("cancel");
    setIsModalOpen2(false);
  };
  function OpenModalDeleteFunc() {
    return (
      <div>
        {" "}
        <Modal
          okText="Delete"
          width={"50%"} // Set the width of the Modal
          title="Delete Source"
          open={isModalOpen2}
          onOk={handleOk2}
          onCancel={handleCancel2}
        >
          <p>{ObjectForDelete}</p>
        </Modal>
      </div>
    );
  }
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    // Update state with the selected file
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = () => {
    // Perform file upload logic here, e.g., send the file to a server

    // For demonstration purposes, you can log the file information to the console
    if (selectedFile) {
      console.log("Selected File:", selectedFile);
    } else {
      console.log("No file selected.");
    }
  };

  function OpenModalCreateFunc() {
    return (
      <div>
        {" "}
        <Modal
          okText="Create"
          width={"50%"} // Set the width of the Modal
          title="Create Source"
          open={isModalOpen1}
          onOk={handleOk1}
          onCancel={handleCancel1}
        >
          <a style={{ color: "black" }}>Name*</a>
          <Input
            style={{ height: "55px" }}
            placeholder="Name"
            value={SourceName1}
            onChange={handleChangeName1}
          />
          <br></br>
          <br></br>

          <div style={{}}>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Environment
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Environment1}
                  label="Environment"
                  onChange={handleChangeEnvironment1}
                >
                  <MenuItem value={"CTV"}>CTV</MenuItem>
                  <MenuItem value={"Mobile App"}>Mobile App</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <br></br>

          <div style={{}}>
            {/* <a style={{ color: "black" }}>Seat</a> */}
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Seat</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Seat1}
                  label="Seat"
                  onChange={handleChangeSeat1}
                >
                  <MenuItem value={"3"}>Shauking</MenuItem>
                  <MenuItem value={"1"}>O2R</MenuItem>
                  <MenuItem value={"4"}>Oshi</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>

          <br></br>
          <div style={{}}>
            <Box
              maxRows={4}
              sx={{
                py: 2,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <form
                style={{ width: "100%" }}
                value={Bundles1}
                onChange={handleChangeBundle1}
                onSubmit={(event) => {
                  event.preventDefault();
                }}
              >
                <Textarea
                  value={Bundles1}
                  placeholder="Bundles"
                  required
                  sx={{ mb: 1 }}
                  maxRows={4}
                />
                {/* <Button type="submit">Submit</Button> */}
              </form>
            </Box>
          </div>
          <div>
            <input type="file" onChange={handleFileChange} />
            <button onClick={handleUpload}>Upload</button>
          </div>
          {/* <p>Some contents...</p> */}
        </Modal>
      </div>
    );
  }

  const EditSource = async (event) => {
    var newObj = {
      id: IdForUpdate2,
      //sourceId: SourceName1,
      seatId: Seat2,
      name: SourceName2,
      trafficSource: "",
      environment: Environment2,
      targeting: Bundles2,
      wl: "",
      whiteListId: "",
      prevWhiteListId: "",
    };

    console.log(newObj);
    try {
      //Array = Array.filter((item) => item !== timeTaken);
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/UpdateOrCreateWL`,
        newObj,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log(response);
      //getCustomersData(startDate, endDate);
      //CallData1();
    } catch (error) {
      console.log("error in Edit Source");
    }
  };
  function OpenModalEditFunc() {
    return (
      <div>
        {" "}
        <Modal
          okText="Edit"
          width={"50%"} // Set the width of the Modal
          title="Edit Source"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <a style={{ color: "black" }}>Name*</a>
          <Input
            style={{ height: "55px" }}
            placeholder="Name"
            value={SourceName2}
            onChange={handleChangeName2}
          />
          <br></br>
          <br></br>
          <div style={{}}>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Environment
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Environment2}
                  label="Environment"
                  onChange={handleChangeEnvironment2}
                >
                  <MenuItem value={"CTV"}>CTV</MenuItem>
                  <MenuItem value={"Mobile App"}>Mobile App</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <br></br>

          <div style={{}}>
            {/* <a style={{ color: "black" }}>Seat</a> */}
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Seat</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Seat2}
                  label="Seat"
                  onChange={handleChangeSeat2}
                >
                  <MenuItem value={"3"}>Shauking</MenuItem>
                  <MenuItem value={"1"}>O2R</MenuItem>
                  <MenuItem value={"4"}>Oshi</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>

          <br></br>
          <div style={{}}>
            <Box
              sx={{
                py: 2,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <form
                style={{ width: "100%" }}
                value={Bundles2}
                onChange={handleChangeBundle2}
                onSubmit={(event) => {
                  event.preventDefault();
                }}
              >
                <Textarea
                  maxRows={4}
                  placeholder="Bundles"
                  required
                  sx={{ mb: 1 }}
                  value={Bundles2}
                />
                {/* <Button type="submit">Submit</Button> */}
              </form>
            </Box>
          </div>

          <div>
            <input type="file" onChange={handleFileChange} />
            <button onClick={handleUpload}>Upload</button>
          </div>
          {/* <p>Some contents...</p> */}
        </Modal>
      </div>
    );
  }

  const handleChangeSourceName = (event) => {
    // Use the spread operator to create a new object with the updated value
    setObjectForChange((prevState) => ({
      ...prevState,
      sourceName: event.target.value,
    }));
    console.log(event);
    console.log(ObjectForChange);
  };

  const handleChangeEnvironment = (event) => {
    // Use the spread operator to create a new object with the updated value
    setObjectForChange((prevState) => ({
      ...prevState,
      environment: event.target.value,
    }));
    console.log(event);
    console.log(ObjectForChange);
  };

  return (
    <div
      style={{
        //flex: 1,
        //  display: "flex", // For desktop should flex it  put for mobile when unable it (no flex)
        // paddingRight: "1%",
        display: "flex", // width > 766 ? "flex" : "",
        flexGrow: 1,
      }}
    >
      {/* <MainPageLeftDrawer /> */}
      <div style={{ width: "100%" }}>
        {Loading ? (
          <>
            <WhiteListsFirstTable
              onSendDataForDelete={receiveDataFromChildForDelete}
              onSendData={receiveDataFromChild}
              SendDataToFirstTable={SendDataToFirstTable}
              startDate={startDate}
              endDate={endDate}
            />

            <div
              style={{
                justifyContent: "flex-end",
                display: "flex",
                height: 80,
              }}
            >
              <img
                src={add}
                style={{ width: 80, cursor: "pointer", paddingRight: 40 }}
                onClick={() => {
                  setIsModalOpen1(true);
                }}
              ></img>
            </div>
            <div style={{ flex: 0, display: "flex" }}>
              {OpenModalCreateFunc()}
              {OpenModalDeleteFunc()}
              {OpenModalEditFunc()}
            </div>
          </>
        ) : (
          <div
            style={{
              flex: 1,
              height: 500,
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Skeleton
              animation="wave"
              width={window.innerWidth}
              height={"100%"}
              borderRadius={100}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default withRouter(WhiteLists);
